<script lang="ts" setup>
  import { computed, toRefs } from 'vue'
  import { DateTime } from 'luxon'

  interface Props {
    baseDate?: string
  }

  const props = defineProps<Props>()

  const { baseDate } = toRefs(props)

  const value = defineModel<string>()

  const wrapper = computed({
    get: () => {
      if (!value.value) return undefined
      return DateTime.fromISO(value.value).toFormat('HH:mm')
    },
    set: (v) => {
      if (!v) {
        value.value = undefined
        return
      }
      const [hours, minutes] = v.split(':').map(Number)
      if (baseDate.value)
        value.value = DateTime.fromISO(baseDate.value)
          .startOf('day')
          .set({
            hour: hours,
            minute: minutes
          })
          .toISO({ suppressMilliseconds: true })!
      else {
        value.value = DateTime.now()
          .startOf('hour')
          .set({
            hour: hours,
            minute: minutes
          })
          .toISO({ suppressMilliseconds: true })
      }
    }
  })
</script>

<template>
<!--  <input
    ref="inputRef"
    v-model="wrapper"
    :class="{ 'p-filled': true }"
    class="block w-full rounded-md shadow-sm border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 h-8"
    type="time"
    v-bind="$attrs" />-->

  <InputText
    ref="inputRef"
    v-model="wrapper"
    :class="{ 'p-inputwrapper-filled': true }"
    class="w-full"
    type="time"
    v-bind="$attrs" />
</template>
